import { useEffect } from "react";

function FeedbackMessage({ message, type, onClose }) {
  useEffect(() => {
    if (!message) {
      return undefined;
    }

    const timerId = setTimeout(() => {
      if (onClose) {
        onClose();
      }
    }, 3500);

    return () => clearTimeout(timerId);
  }, [message, onClose]);

  if (!message) {
    return null;
  }

  return (
    <div className={`feedback ${type}`} role="status" aria-live="polite">
      <span>{message}</span>
      <button type="button" className="feedback-close" onClick={onClose} aria-label="Cerrar aviso">
        ×
      </button>
    </div>
  );
}


export default FeedbackMessage;